const FALLBACK_NAME = "Unknown";
const FALLBACK_INITIAL = "?";

/**
 * Extracts a display name and initial from an email address.
 *
 * Takes the local part before `@`, capitalises the first letter, and
 * returns both the formatted name and its first-letter initial.
 * Falls back to "Unknown" / "?" when the email is empty, nullish, or
 * has no usable local part (e.g. "@domain.com").
 *
 * @param email - Full email address (e.g. "abc@email.com")
 * @returns `{ name, initial }` where name is title-cased local part and initial is its first character
 */
export const createNameAndInitialFromEmail = (
  email: string,
): { name: string; initial: string } => {
  const localPart = (email ?? "").split("@")[0] ?? "";

  if (!localPart) {
    return { name: FALLBACK_NAME, initial: FALLBACK_INITIAL };
  }

  const name = localPart.charAt(0).toUpperCase() + localPart.slice(1);
  const initial = name.charAt(0);
  return { name, initial };
};
